export const QUERY_CONSTANTS = {
  CURRENT_USER: "currentUser",
  MODULES: "modules",
  MODULE_FEATURES: "moduleFeatures",
  COMPANY: "company",
  PIPELINE_METRICS: "pipelineMetrics",
  PROJECT_SUCCESS_RATE: "projectSuccessRate",
  QUALITY_SCORE: "qualityScore",
  DEFECT_DENSITY: "defectDensity",
  REVENUE_GROWTH: "revenueGrowth",
  CUSTOMER_ACQUISITION: "customerAcquisition",
  MARKET_SHARE: "marketShare",
  COST_SAVINGS: "costSavings",
  CUSTOMER_SATISFACTION: "customerSatisfaction",
  MARKET_TRENDS: "marketTrends",
  PROCESS_OPTIMIZATION: "processOptimization",
  RESOURCE_UTILIZATION: "resourceUtilization",
  SUMMARY_REVENUE: "summaryRevenue",
  SUMMARY_PROJECTS: "summaryProjects",
  SUMMARY_TEAM: "summaryTeam",
  SUMMARY_QUALITY: "summaryQuality",
  SUMMARY_CUSTOMERS: "summaryCustomers",
  SUMMARY_EFFICIENCY: "summaryEfficiency",
  PERMISSIONS: "permissions",
  PERMISSION: "permission",
  USERS: "users",
  USER: "user",
  PERMISSION_GROUPS: "permissionGroups",
  PERMISSION_GROUP: "permissionGroup",
  DASHBOARD_STATS: "dashboardStats",
};
